export const questions = [
 {
  question:
   "Sếp yêu cầu bạn làm lại bản báo cáo gấp, dù bạn nghĩ mình đã làm đúng. Bạn sẽ:",
  options: [
   "Gật đầu làm lại, không hỏi thêm gì",
   "Giải thích nhẹ nhàng tại sao bạn làm như vậy",
   "Phản ứng gay gắt vì thấy vô lý",
   "Làm lại nhưng thầm bực bội trong lòng",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question: "Khi đồng nghiệp góp ý công việc bạn chưa hiệu quả, bạn:",
  options: [
   "Lập tức phản bác để bảo vệ mình",
   "Nghe hết rồi hỏi ngược lại để hiểu rõ hơn",
   "Giận nhưng im lặng",
   "Cảm ơn nhưng không thực sự để tâm",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question: "Bạn có xu hướng:",
  options: [
   "Thể hiện quan điểm mạnh mẽ bất chấp hậu quả",
   "Phân tích tình huống trước khi phát biểu",
   "Tránh tranh luận để giữ hòa khí",
   "Chờ người khác lên tiếng trước",
  ],
  points: [1, 3, 1, 0],
 },
 {
  question: "Gặp mâu thuẫn với cấp trên, bạn thường:",
  options: [
   "Tránh mặt cho qua chuyện",
   "Hỏi lại để làm rõ và điều chỉnh nếu cần",
   "Nói thẳng, dù có thể làm mất lòng",
   "Giữ trong lòng, rồi tìm người thứ ba để xả",
  ],
  points: [1, 3, 1, 0],
 },
 {
  question: "Trong buổi họp, bạn không đồng tình với ý kiến nhóm. Bạn sẽ:",
  options: [
   "Không nói gì, chờ kết thúc",
   "Nêu quan điểm bằng dẫn chứng cụ thể",
   "Phản bác ngay lập tức",
   "Ghi lại, định inbox riêng sau",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question: "Khi được giao việc gấp mà không được giải thích rõ, bạn:",
  options: [
   "Làm theo cho xong",
   "Hỏi lại để hiểu rõ yêu cầu",
   "Tức giận vì bị áp đặt",
   "Làm nhưng khó chịu và mất động lực",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question:
   "Một đồng nghiệp hiểu sai ý bạn trong email và phản ứng tiêu cực. Bạn:",
  options: [
   "Mặc kệ, họ nghĩ gì thì nghĩ",
   "Gửi lại mail làm rõ, giữ thái độ tích cực",
   "Phản ứng lại bằng một mail gay gắt",
   "Tâm sự với người khác để lấy lại công bằng",
  ],
  points: [0, 3, 1, 2],
 },
 {
  question: "Sếp góp ý bạn hơi thụ động trong các buổi họp. Bạn:",
  options: [
   "Cảm thấy tổn thương và im lặng",
   "Chủ động hỏi thêm góp ý để cải thiện",
   'Phản ứng: "Em đâu có như vậy!"',
   "Nghĩ sếp đang thiên vị người khác",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question: "Khi người khác hiểu lầm bạn, bạn:",
  options: [
   "Im lặng vì nghĩ người hiểu mình sẽ hiểu",
   "Gặp trực tiếp để giải thích rõ ràng",
   "Đăng status bóng gió",
   "Cố gắng tránh va chạm thêm",
  ],
  points: [1, 3, 1, 2],
 },
 {
  question: "Bạn thường đưa ra ý kiến khi:",
  options: [
   "Có ai đó hỏi",
   "Đã phân tích và cân nhắc rõ ràng",
   "Không đồng tình với người khác",
   "Muốn khẳng định mình",
  ],
  points: [1, 3, 1, 0],
 },
];
